import Button from "react-bootstrap/Button";
import { VerifiedTooltip } from "../Atomics/CustomCheckTooltips/CustomCheckTooltips";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBell } from "@fortawesome/free-solid-svg-icons";
import { baseURL } from "../../api/dataFetcher";
import LoadingIndicator from "../Atomics/Loading/Loading";

export default function AuthorBox({
  subscriberCount,
  imgAlt = "",
  imgSrc,
  isSubscribed = false,
  channelHref = "#",
  channelName,
  verified = null,
  publishedOn,
  handleSubscribe,
  subscribeLoading,
}) {
  return (
    <>
      <div className="single-video-author box mb-3">
        <div className="float-left">
          <Button variant="info" onClick={handleSubscribe}>
            {subscribeLoading ? (
              <LoadingIndicator size="sm" padding="2px" />
            ) : isSubscribed ? (
              "عضو هستید"
            ) : (
              "عضو شوید"
            )}
          </Button>{" "}
          {/* <Button variant="outline-info">
            <FontAwesomeIcon icon={faBell} />
          </Button> */}
        </div>
        <img
          className="img-fluid float-right ml-3"
          src={imgSrc ? baseURL + imgSrc : "/img/s4.png"}
          alt={imgAlt}
        />
        <p>
          <a href={channelHref} className="text-danger-custom">
            <strong>{channelName}</strong>
          </a>{" "}
          {verified ? <VerifiedTooltip /> : ""}
        </p>
        <small>تاریخ انتشار {publishedOn}</small>
      </div>
    </>
  );
}
